import middleware from "../../lib/middleware";
import { add_notification, remove_notificationByType } from '../../redux/fetchActions';
import { NotificationType } from './constant';
import soundPlayer from './soundPlayer';

let mwHandler;

export default function getHandler(options = {}) {
    if (mwHandler) return mwHandler;
    mwHandler = middleware();
    const { dispatch } = options;
    mwHandler.use(shortCircuitNonNotificationInfo);
    mwHandler.use(shortCircuitAppUpdateRequired);
    mwHandler.use(buildTechInTheWayHandler(dispatch));
    mwHandler.use(paymentOrderRequired(dispatch));
    mwHandler.use(aptmCancelledByTechnician(dispatch));
    mwHandler.use(technicianArrived(dispatch));
    mwHandler.use(genericNotifHandler(dispatch));
    mwHandler.use(soundPlayer(dispatch));
    return mwHandler
}

const shortCircuitNonNotificationInfo = ({ next }, notifInfo) => notifInfo ? next() : null;

const shortCircuitAppUpdateRequired = ({ next }, notifInfo) => {
    if (notifInfo.type === NotificationType.appUpdateRequired) {
        return;
    }
    next();
};

/**
 * buildTechInTheWayHandler
 * @param dispatch es la func dispatch de redux que permite lanzar actions en el store.
 * @return {Function}
 */
function buildTechInTheWayHandler(dispatch) {
    return ({ next }, notifInfo) => {
        const { type, title, body } = notifInfo;
        if (type === NotificationType.techOnTheWay) {
            dispatch(add_notification({ type: NotificationType.techOnTheWay, title, message: body, }));
        }
        next();
    };
}

/**
 * paymentOrderRequired
 * @param dispatch es la func dispatch de redux que permite lanzar actions en el store.
 * @return {function}
 */
function paymentOrderRequired(dispatch) {
    return async ({ next }, notifInfo) => {
        const { type, title, body } = notifInfo;
        if (type === NotificationType.paymentOrderRequired) {
            dispatch(add_notification({ type: NotificationType.paymentOrderRequired, title, message: body, }));
        }
        next()
    }
}

function technicianArrived(dispatch) {
    return async ({ next }, notifInfo) => {
        const { type, title, body } = notifInfo;
        if (type === NotificationType.techArrived) {
            dispatch(remove_notificationByType(NotificationType.techOnTheWay));
            dispatch(add_notification({ type: NotificationType.techArrived, title, message: body, }));
        }
        next()
    }
}

/**
 * aptmCancelledByTechnician
 * @param dispatch es la func dispatch de redux que permite lanzar actions en el store.
 * @return {function}
 */
function aptmCancelledByTechnician(dispatch) {
    return async ({ next }, notifInfo) => {
        const { type, title, body } = notifInfo;
        if (type === NotificationType.aptmCancelled) {
            dispatch(add_notification({ type: NotificationType.aptmCancelled, title, message: body, }));
        }
        next()
    }
}

function genericNotifHandler(dispatch) {
    return ({ next }, notifInfo) => {
        const { type, title, body } = notifInfo;
        if (type === NotificationType.generic) {
            dispatch(add_notification({ type: NotificationType.generic, title, message: body, }));
        }
        next()
    }
}
